import { render, staticRenderFns } from "./StudentResidences.vue?vue&type=template&id=16091c4c"
import script from "./StudentResidences.vue?vue&type=script&lang=js"
export * from "./StudentResidences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports